import { EmptyState, FlexColumn, FlexRow, StyledButton, StyledSearchBar } from '@gorila-shared-ui/components';
import { StatefulPanel } from 'baseui/accordion';
import { Badge } from 'baseui/badge';
import { LabelMedium, LabelXSmall } from 'baseui/typography';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import {
  activeEventSettingsState,
  eventSettingsByCategoriesState,
  eventSettingsCountState,
  searchEventSettingsState,
  selectedEventSettingState,
} from '../../../storage/eventSettings';
import EventItem from './EventItem';

export function EventList() {
  const { css, theme, classes, concatenateClasses } = useStyles();
  const eventSettingsByCategory = useRecoilValue(eventSettingsByCategoriesState);
  const eventSettingsCount = useRecoilValue(eventSettingsCountState);
  const resetSelectedEvent = useResetRecoilState(selectedEventSettingState);
  const [search, setSearch] = useRecoilState(searchEventSettingsState);
  const [active, setActive] = useRecoilState(activeEventSettingsState);

  useEffect(() => {
    return () => {
      resetSelectedEvent();
    };
  }, []);

  return (
    <FlexColumn classNames={css({ height: '100%' })}>
      {!eventSettingsByCategory && <EmptyState title="No hay notificaciones que se deban configurar" />}
      {eventSettingsByCategory && (
        <>
          <FlexRow gap={theme.sizing.scale300}>
            <StyledSearchBar
              value={search}
              onChange={(newSearch) => {
                resetSelectedEvent();
                setSearch(newSearch);
              }}
              noMargin
            />
            <StyledButton
              kind={active ? 'primary' : 'secondary'}
              onClick={() => {
                resetSelectedEvent();
                setActive((prev) => !prev);
              }}
            >
              Solo activas
            </StyledButton>
          </FlexRow>
          {!!eventSettingsByCategory.length && (
            <>
              <ul
                className={css({
                  margin: 0,
                  paddingLeft: 0,
                  paddingRight: 0,
                  height: '100%',
                  flex: 1,
                  overflowY: 'auto',
                })}
              >
                {eventSettingsByCategory.map((data) => (
                  <StatefulPanel
                    initialState={{
                      expanded: true,
                    }}
                    title={
                      <FlexRow classNames={concatenateClasses(classes.centeredBetween, css({ width: '100%' }))}>
                        <LabelMedium>{data.categoryDisplay}</LabelMedium>
                        <Badge
                          color="primary"
                          content={data.settings?.length ?? 0}
                        />
                      </FlexRow>
                    }
                    key={data.category}
                    onChange={() => {
                      resetSelectedEvent();
                    }}
                    overrides={{
                      Content: {
                        style: {
                          paddingTop: '0',
                          paddingBottom: '0',
                          paddingRight: '0',
                          paddingLeft: '20px',
                        },
                      },
                    }}
                  >
                    <ul
                      className={css({
                        margin: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        height: '100%',
                        flex: 1,
                      })}
                    >
                      {data.settings?.map((setting, index) => (
                        <EventItem
                          key={setting.category + '-' + index}
                          eventSetting={setting}
                        />
                      ))}
                    </ul>
                  </StatefulPanel>
                ))}
              </ul>
              <LabelXSmall color={theme.colors.contentSecondary}>{eventSettingsCount}</LabelXSmall>
            </>
          )}
          {!eventSettingsByCategory.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
    </FlexColumn>
  );
}
